import { sendGaEvent, setGaEduCode, setGaUserRole } from './gtag';
import {
  AppNavPayload,
  BatchZipFileFailedPayload,
  BatchZipStalledPayload,
  BatchZipStartedPayload,
  BatchZipTerminalPayload,
  DownloadAllStartPayload,
  DownloadCompletePayload,
  DownloadHistoryPayload,
  DownloadStartPayload,
  DownloadStatusPayload,
  LatestNewsReadMorePayload,
  EduCode,
  LocalFilePayload,
  PageViewPayload,
  ResourceCategoryPayload,
  ResourceFilterPayload,
  ResourceInternetLinkClickPayload,
  ResourceInternetTabPayload,
  TrackingEventName,
  UserRole,
} from './type';

/**
 * Tracking 事件對外入口
 *
 * 每個 xxxEvent function 代表一個商業事件，內部可同時派發到多個渠道
 * （目前只有 GA，未來加其他事件工具時在此統一擴充，
 *  呼叫端無需更動）。
 *
 */

/** 登入 / 身份變更時呼叫一次，之後事件會自動帶上 user_role */
export const updateUserRole = (role: UserRole) => {
  setGaUserRole(role);
};

/** 登入 / 身份變更時呼叫一次，之後事件會自動帶上 edu_code（國小/國中/高中） */
export const updateEduCode = (edu: EduCode) => {
  setGaEduCode(edu);
};

export const pageViewEvent = (payload: PageViewPayload) => {
  sendGaEvent(TrackingEventName.PageView, payload);
};

export const resourceFilterEvent = (payload: ResourceFilterPayload) => {
  sendGaEvent(TrackingEventName.ResourceFilter, payload);
};

export const resourceCategoryEvent = (payload: ResourceCategoryPayload) => {
  sendGaEvent(TrackingEventName.ResourceCategory, payload);
};

export const resourceInternetTabEvent = (
  payload: ResourceInternetTabPayload,
) => {
  sendGaEvent(TrackingEventName.ResourceInternetTab, payload);
};

export const resourceInternetLinkClickEvent = (
  payload: ResourceInternetLinkClickPayload,
) => {
  sendGaEvent(TrackingEventName.ResourceInternetLinkClick, payload);
};

export const downloadStartEvent = (payload: DownloadStartPayload) => {
  sendGaEvent(TrackingEventName.DownloadStart, payload);
};

export const downloadAllStartEvent = (payload: DownloadAllStartPayload) => {
  sendGaEvent(TrackingEventName.DownloadAllStart, payload);
};

export const downloadStatusEvent = (payload: DownloadStatusPayload) => {
  sendGaEvent(TrackingEventName.DownloadStatus, payload);
};

export const downloadCompleteEvent = (payload: DownloadCompletePayload) => {
  sendGaEvent(TrackingEventName.DownloadComplete, payload);
};

export const downloadHistoryEvent = (payload: DownloadHistoryPayload) => {
  sendGaEvent(TrackingEventName.DownloadHistory, payload);
};

export const localFileEvent = (payload: LocalFilePayload) => {
  sendGaEvent(TrackingEventName.LocalFile, payload);
};

export const appNavEvent = (payload: AppNavPayload) => {
  sendGaEvent(TrackingEventName.AppNav, payload);
};

export const latestNewsReadMoreEvent = (payload: LatestNewsReadMorePayload) => {
  sendGaEvent(TrackingEventName.LatestNewsReadMore, payload);
};

export const batchZipStartedEvent = (payload: BatchZipStartedPayload) => {
  sendGaEvent(TrackingEventName.BatchZipStarted, payload);
};

export const batchZipTerminalEvent = (payload: BatchZipTerminalPayload) => {
  sendGaEvent(TrackingEventName.BatchZipTerminal, payload);
};

export const batchZipFileFailedEvent = (payload: BatchZipFileFailedPayload) => {
  sendGaEvent(TrackingEventName.BatchZipFileFailed, payload);
};

export const batchZipStalledEvent = (payload: BatchZipStalledPayload) => {
  sendGaEvent(TrackingEventName.BatchZipStalled, payload);
};

export type {
  AppNavPayload,
  BatchZipFileFailedPayload,
  BatchZipStalledPayload,
  BatchZipStartedPayload,
  BatchZipTerminalPayload,
  DownloadAllStartPayload,
  DownloadCompletePayload,
  DownloadHistoryPayload,
  DownloadStartPayload,
  DownloadStatusPayload,
  LatestNewsReadMorePayload,
  EduCode,
  LocalFilePayload,
  PageViewPayload,
  ResourceCategoryPayload,
  ResourceFilterPayload,
  ResourceInternetLinkClickPayload,
  ResourceInternetTabPayload,
  UserRole,
};
